﻿import axios from "axios";
import { initializeApp } from "firebase/app";
import {
  FirebaseStorage,
  getStorage,
  ref,
  listAll,
  getDownloadURL,
} from "firebase/storage";
import { FrameLevelCellid } from "../util";
import { ICloudStorageAccess } from "./cloudStorageAccess";
import { ImageChunk } from "../util/image";
import { PreviewDaishi, TagID } from "../entities";

const config = {
  // TODO: API キーをリポジトリ管理下から除外する
  // @see: https://qiita.com/HorieH/items/8b4b1c4807e1eb6fcb0a#補足firebaseのapiキーを隠しファイルenvで管理
  apiKey: "AIzaSyA0WEi9-AifP_myMFzZfkWKmLawzI9cgNo",
  authDomain: "essential-haiku-207806.firebaseapp.com",
  databaseURL: "https://essential-haiku-207806.firebaseio.com",
  projectId: "essential-haiku-207806",
  storageBucket: "essential-haiku-207806.appspot.com",
  messagingSenderId: "632118722038",
  appId: "1:632118722038:web:d61500542bc0a066",
};

const firebaseApp = initializeApp(config);

/**
 * Firebase Storage 上の プレビュー台紙情報へのアクセスを提供します。
 */
export class FirebaseAccess implements ICloudStorageAccess {
  private readonly storage: FirebaseStorage;
  private readonly prefix: string;

  constructor(prefix: string = "sample") {
    // let currentUser = firebase.auth().currentUser;
    // if (!currentUser) throw new Error('currentUser is null');
    console.log(`FirebaseAccess init with ${prefix}`);
    this.storage = getStorage(firebaseApp, `gs://sdesktop.online`);
    this.prefix = prefix;
  }

  // loadPreviewDaishi は、`header.txt` 読み込み、プレビュー台紙オブジェクトを生成します。
  public async loadPreviewDaishi(tag: TagID): Promise<PreviewDaishi> {
    const fileRef = ref(this.storage, `${this.prefix}/${tag}/header.txt`);
    const url = await getDownloadURL(fileRef);
    const response = await axios.get(url);
    return PreviewDaishi.parseText(response.data);
  }

  public async resolveUrl(
    tag: TagID,
    frame: FrameLevelCellid,
  ): Promise<ImageChunk> {
    const source = frame.fromR,
      dest = frame.toR,
      cellid = frame.cellid,
      level = frame.level,
      filename = `cell.${level}.${cellid.x}.${cellid.y}.jpg`,
      fileRef = ref(this.storage, `${this.prefix}/${tag}/${filename}`);

    return getDownloadURL(fileRef).then((url) => {
      console.debug(url);
      return new ImageChunk(url, source, dest);
    });
  }

  public async listTags(): Promise<TagID[]> {
    return listAll(ref(this.storage, `${this.prefix}/`)).then((res) => {
      return res.prefixes.map((folderRef) => {
        return new TagID(folderRef.name);
      });
    });
  }
}
